import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageRetryEvent } from '../copilot/copilot.component';
import { ContentBlockType, CopilotMessage, CopilotTextContentBlock } from '../models/copilot.interface';

@Component({
  selector: 'sbnb-user-message',
  templateUrl: './user-message.component.html',
})
export class UserMessageComponent {
  @Input() message!: CopilotMessage;
  @Input() hasError = false;
  @Input() progressMessage: string | null = null;

  @Output() retryClick = new EventEmitter<MessageRetryEvent>();

  readonly ContentBlockType = ContentBlockType;

  get textContent(): string {
    if (!this.message.data || this.message.data.length === 0) {
      return '';
    }

    const textBlocks = this.message.data
      .filter((block) => block.type === ContentBlockType.Text)
      .map((block) => (block as CopilotTextContentBlock).content);

    return textBlocks.join('\n\n');
  }

  onRetryClick(): void {
    this.retryClick.emit({ messageUuid: this.message.uuid });
  }
}
